<div *ngIf="surveyEditorService.surveyEditor$().activeQuestion as activeQuestion" [formGroup]="activeQuestion" class="single-choice-settings__container">
  <div class="single-choice-settings__input-containers">
    <empathy-required-setting [activeQuestion]="activeQuestion"></empathy-required-setting>
    <empathy-randomized-options-setting [activeQuestion]="activeQuestion"></empathy-randomized-options-setting>
    <empathy-min-view-time-setting [activeQuestion]="activeQuestion" [showBorder]="false"></empathy-min-view-time-setting>
  </div>
  <empathy-media-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-media-settings>
  <empathy-choice-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-choice-settings>
</div>
